import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import KofloContent from "./KofloMixerContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/koflo/mixers" component={KofloContent} />
          <Route path="/suppliers/koflo">
            <Redirect to="/suppliers/koflo/mixers" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
